import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { setError } from "../../../../../Redux/ErrorRedux";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Container from "../../../../../modules/commons/Container";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { HttpStatus } from "../../../../common/Constants";
import { mapToObjectDDL } from "../../../../common/mapper";
import LaporanServiceHarian from "./laporanServiceHarian/laporanServiceHarian";
import LaporanServiceMTD from "./laporanServiceMTD/laporanServiceMTD";
import LaporanServiceYTD from "./laporanServiceYTD/laporanServiceYTD";
import LaporanUnitHarian from "./laporanUnitHarian/laporanUnitHarian";
import LaporanUnitMTDByMekanik from "./laporanUnitMTDByMekanik/laporanUnitMTDByMekanik";
import LaporanUnitL3Y from "./laporanUnitL3Y/laporanUnitL3Y";

class DashboardLaporanHarianUnit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cabangOptions: [],
      kodeCabang: null,
      loading: false,
    };
  }

  componentDidMount() {
    this.fetchDataCabang();
  }

  handleSelectCabang = (value) => {
    this.setState((prev) => ({
      ...prev,
      kodeCabang: value,
    }));
  };

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName: "Dashboard Level Mekanik SA - Laporan Harian Unit",
    });
    this.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang),
      );

      if (filteredData.length !== 0) {
        const cabang = filteredData.map((item) =>
          mapToObjectDDL(item.namaDealer, item.kodeCabang),
        );
        this.setState((prev) => ({
          ...prev,
          cabangOptions: cabang,
          kodeCabang: cabang[0],
        }));
      }
    }
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  render() {
    const { cabangOptions, kodeCabang, loading } = this.state;
    return (
      <React.Fragment>
        <Container>
          <FlexView
            style={{ gap: "20px" }}
            className="margin-top-15px"
            vAlignContent="center"
          >
            <label className="margin margin-bottom-15px">Cabang</label>
            <SimpleDDL
              id="select_options_kode_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-350px"
              placeholder="Nama Cabang"
              options={cabangOptions}
              value={kodeCabang}
              onChange={(value) => this.handleSelectCabang(value)}
            />
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Unit Entri Harian</Tab>
              <Tab>Laporan Unit Servis Harian</Tab>
              <Tab>Laporan Servis Harian</Tab>
              <Tab>Laporan Servis MTD</Tab>
              <Tab>Laporan Unit Entri MTD By Mekanik</Tab>
              <Tab>Laporan Unit Servis MTD By Mekanik</Tab>
              <Tab>Laporan Servis YTD</Tab>
              <Tab>Laporan Unit Entri 3 Tahun Terakhir</Tab>
              <Tab>Laporan Unit Servis 3 Tahun Terakhir</Tab>
            </TabList>
            <TabPanel>
              <LaporanUnitHarian
                type="unit_entri"
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanUnitHarian
                type="servis"
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanServiceHarian
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanServiceMTD
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanUnitMTDByMekanik
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                type="unit_entri"
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanUnitMTDByMekanik
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                type="unit_servis"
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanServiceYTD
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanUnitL3Y
                type="unit_entri"
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanUnitL3Y
                type="servis"
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
          </Tabs>
        </Container>
        {loading && <SimpleLoadingOverlay active={loading} />}
      </React.Fragment>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  setError: (payload) => dispatch(setError(payload)),
});

const mapStateToProps = (state) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardLaporanHarianUnit);
